import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import ui from 'modules/ui';
import { FavoriteCountType } from '../../types';

const {
    selectors: {
        selectUpcomingFavoriteCount,
        selectAllFavoriteCount,
        selectOutrightsFavoriteCount,
    },
} = ui;

interface Input {
    type: FavoriteCountType;
}

interface Output {
    count: number | null;
}

const makeCountSelector = (type: FavoriteCountType) => {
    switch (type) {
        case 'upcoming':
            return selectUpcomingFavoriteCount;
        case 'outrights':
            return selectOutrightsFavoriteCount;

        default:
            return selectAllFavoriteCount;
    }
};

function useFavoriteCount({ type }: Input): Output {
    const selectCount = useMemo(() => makeCountSelector(type), [type]);

    const count = useSelector(selectCount);

    return { count };
}

export default useFavoriteCount;
